import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
    countryFind(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/country/find`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    countrySave(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/country/save`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    countryView(id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/country/view/` + id, null)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    countryUpdate(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/country/update`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	countryDelete(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/country/delete`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
    countryList(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/country/list`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	countryImport(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostImport(`/country/import`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	countryImportProceed(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/country/import/proceed`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	countryExport(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/country/export`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
}
